/**
 * Generates a random position near a given center point within a specified radius.
 * @param {number} centerX - The x-coordinate of the center point.
 * @param {number} centerY - The y-coordinate of the center point.
 * @param {number} radius - The maximum distance from the center.
 * @returns {{x: number, y: number}} - The randomly generated position.
 */
export function getRandomPositionNear(centerX, centerY, radius) {
    const angle = Math.random() * Math.PI * 2; // Random angle (0 to 2*PI)
    const distance = Math.random() * radius;   // Random distance (0 to radius)
    
    const x = centerX + Math.cos(angle) * distance;
    const y = centerY + Math.sin(angle) * distance;
    
    return { x, y };
} 